import { StyleDeclarationValue, css } from 'aphrodite';
import { styleSheet } from './styles';

interface IProps {
	companyDisplayName?: string;
	name?: string;
	styles?: StyleDeclarationValue[];
	logoUrl?: string;
}

export function SurveyHeader({ name, companyDisplayName, styles = [], logoUrl }: IProps) {
	if (!name) {
		return null;
	}
	return (
		<section className={css(styleSheet.header, ...styles)}>
			{logoUrl ? (
				<img
					src={logoUrl}
					className={css(styleSheet.logo)}
					alt='Survey Logo'
					onError={e => {
						(e.target as HTMLImageElement).style.display = 'none';
					}}
				/>
			) : null}
			<h2 className={css(styleSheet.heading)}>{name}</h2>
			{companyDisplayName ? <p>{companyDisplayName}</p> : null}
		</section>
	);
}
